import React from 'react';
import Footer from './Parts/GeneralParts/Footer';
import BannerPrincipal from './Parts/GeneralParts/BannerPrincipal';
import DescripcionStandard from './Parts/DescripcionStandard';
import SolicitarEmpleo from './Parts/GeneralParts/SolicitarEmpleo';
import FormularioContacto from './Parts/Contacto/FormularioContacto';
import UbicacionGoogleMap from './Parts/Contacto/UbicacionGoogleMap';

class Contacto extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            nombre:"Contacto",
            content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            imgBannerPrincipal:[
                {
                    alt:"second_slide",
                    url:"./img/slide_2.jpg"
                }
            ]
        }
    }


    render() {
        return (
            <div className="contenedor_contenido_app">
                <BannerPrincipal imgBannerPrincipal={this.state.imgBannerPrincipal} />
                <DescripcionStandard descriptionObject={this.state} display_value="none" />

                <div className="contenedor_formulario_mapa">
                    <FormularioContacto />
                    <div className="contenedor_google_map">
                        <UbicacionGoogleMap />
                    </div>
                </div>

                <SolicitarEmpleo />
                <Footer />
            </div>
        )
    }
}

export default Contacto;